var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024.0003 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1011.504 481.83L833.328 303.656c-177.474-177.474-465.182-177.474-642.654 0L12.496 481.83c-16.662 16.663-16.662 43.68 0 60.34l178.176 178.177c177.474 177.474 465.182 177.474 642.654 0l178.176-178.176c16.664-16.66 16.664-43.677.002-60.34zM772.988 660.008c-144.148 144.148-377.826 144.148-521.974 0L103.006 512l148.006-148.005c144.148-144.148 377.826-144.148 521.974 0L920.994 512 772.988 660.008zM512 298.667c-117.814 0-213.334 95.518-213.334 213.334S394.186 725.336 512 725.336 725.334 629.815 725.334 512 629.814 298.668 512 298.668zM512 640c-70.686 0-128-57.313-128-128s57.314-128 128-128 128 57.315 128 128-57.314 128-128 128z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.2bc54c2c8e5a4e951b8c6db1fd5b42f6.svg";
export { ForwardRef as ReactComponent };